import { useTheme } from '@/theme/theme.hook';
import { patternsReact } from './pattern';

export function BackgroundPattern() {
    const [theme] = useTheme();
    const patternId = theme.pattern;

    const { size, svg } = patternsReact[patternId];

    return (
        <div className="fixed left-0 top-0 z-0 w-screen h-screen bg-linear-0 from-main-background-bottom to-main-background-top text-pattern-foreground">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" preserveAspectRatio="none">
                <defs>
                    <pattern id={patternId} x="0" y="0" width={size.width} height={size.height} patternUnits="userSpaceOnUse">
                        {svg}
                    </pattern>
                </defs>
                <rect width="100%" height="100%" fill={`url(#${patternId})`} />
            </svg>
        </div>
    );
}